// extracted by mini-css-extract-plugin
export var divider = "_f8-7";
export var itemsToggle = "_f8-8";
export var mergeModal = "_f8-1";
export var optionCard = "_f8-4";
export var radioGroup = "_f8-6";
export var radioOption = "_f8-0";
export var selected = "_f8-5";
export var shipmentOptions = "_f8-2";
export var tableOptions = "_f8-3";